// components/AdminListLeave/AdminListLeave.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Button } from '../UI/Button.js';
import { Dropdown } from '../UI/Dropdown.js';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';
import styled from 'styled-components';
import Select from 'react-select'; // Import react-select

const cellStyle = { border: '1px solid #ccc', padding: '8px' };

const AdminListLeave = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [selectedSignTypes, setSelectedSignType] = useState([]);
  
  const [leaveResults, setLeaveResults] = useState([]);
  const hasNameColumn = leaveResults.some(item => item.name_surname !== null && item.name_surname !== undefined);
  
  // Row selection logic  
  const [selectedRows, setSelectedRows] = useState(new Set());
  
  //This const is to generate unique id for each return row
  const normalizeLeaveData = (data) => {
	return data.map(item => ({
		...item,
		id: `${item.employee_id}_${item.start_time}_${item.type}`
	}));
	};
  
  const toggleSelectRow = (id) => {
     setSelectedRows(prev => {
       const newSet = new Set(prev);
       if (newSet.has(id)) {
         newSet.delete(id);
       } else {
         newSet.add(id);
       }
       return newSet;
     });
   };

   const toggleSelectAll = () => {
     if (selectedRows.size === leaveResults.length) {
       setSelectedRows(new Set());
     } else {
       setSelectedRows(new Set(leaveResults.map(item => item.id)));
     }
   };
   
   const isAllSelected = leaveResults.length > 0 && selectedRows.size === leaveResults.length;
  
   const handleDeleteSelected = async () => {
   const idsToDelete = Array.from(selectedRows);
      try {
			 const response = await api.post('/delete-leaves', { ids: idsToDelete });
			 setLeaveResults(prev => prev.filter(item => !selectedRows.has(item.id)));
			 setSelectedRows(new Set());
			 alert(`${response.data.deleted} registros eliminados.`);
		  } catch (err) {
			 console.error('Delete failed', err);
			 alert('Failed to delete selected records');
		  }   
		 }; 

   const handleDeleteOne = async (id) => {
      try {
             const response = await api.post('/delete-leaves', { ids: [id] });
             setLeaveResults(prev => prev.filter(item => item.id !== id));
             setSelectedRows(prev => {
               const newSet = new Set(prev);
               newSet.delete(id);
               return newSet;
             });
		  alert(`${response.data.deleted} registro eliminado.`);
          } catch (err) {
            console.error('Delete failed', err);
            alert('Failed to delete the record');
          }
         };
  
  //end row selection logic
  const signTypesOptions = [
  { value: 'Vacaciones', label: 'Vacaciones' },
  { value: 'Baja medica', label: 'Baja médica' },
  { value: 'Permiso cuidado de menor', label: 'Permiso cuidado de menor' },
];
  
  const isOptionSelectedEmp = (option) => {
    return selectedEmployees.some(selected => selected.value === option.value);
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years
  const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12
  const isOptionSelected = (option) => {
    return selectedSignTypes.some(selected => selected.value === option.value);
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get('/userlist');
        setEmployees(response.data.map(emp => ({ value: emp.user_id, label: `${emp.name} ${emp.surnames}` })));
      } catch (error) {
        console.error('Failed to fetch employees', error);
      }
    };
    fetchEmployees();
  }, []);

  const handleListLeave = async () => {
  try {
    let url = '/listleaves';
    const params = new URLSearchParams();
    if (year) params.append('year', year); 
    if (month) params.append('month', month);
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
	
	const payload = {
        'leave_types_filter': {leave_types: selectedSignTypes.map(option => option.value)},
		'employee_filter': {employee_ids: selectedEmployees.map(emp => emp.value)}
      };

    const response = await api.post(url, payload);
	if (response.data.length === 0) {
      alert('No se encontraron ausencias con los filtros seleccionados.');
    }
	setLeaveResults(normalizeLeaveData(response.data));
	//setYear(null);
	//setMonth(null);
	//setSelectedSignType(signTypesOptions)
  } catch (error) {
      console.error('Listing leave failed', error);
      alert('Listing leave failed');
	  }
  };
  
  return (
    <div>
      <h2>Lista de ausencias</h2>
	  <FormContainer>
	  <FullWidth>
          <Select
            isMulti
            options={employees}
            value={selectedEmployees}
            onChange={(selectedOptions) => setSelectedEmployees(selectedOptions)}
            placeholder="Selecciona empleado/s"
			isOptionSelected={isOptionSelectedEmp}
			closeMenuOnSelect={false}
          />
        </FullWidth>
      <FullWidth>
          <Dropdown value={year} onChange={(e) => setYear(e.target.value)} >
            <option value="">Año</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={month} onChange={(e) => setMonth(e.target.value)} >
            <option value="">Mes</option>
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
	   <FullWidth>
			<Select
				isMulti
				onChange={(selectedOptions) => setSelectedSignType(selectedOptions)}
				placeholder="Selecciona tipo de ausencia"
				isOptionSelected={isOptionSelected}
				closeMenuOnSelect={false}
				options={signTypesOptions}
			/>
	  </FullWidth>
	  <FullWidth>
      <Button onClick={handleListLeave}>Mostrar</Button>
	  </FullWidth>
	  </FormContainer>
	  
	  {/* Return table section in a div */}
	  {leaveResults.length > 0 && (
    <div style={{ marginTop: '20px' }}>
    {selectedRows.size > 0 && (
  	<div style={{ marginTop: '10px' }}>
  		<Button onClick={handleDeleteSelected}>
  			Eliminar seleccionados ({selectedRows.size})
  		</Button>
  	</div>
  	)}
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
      <thead>
		<tr>
		    <th style={cellStyle}>
				<input
					type="checkbox"
					checked={isAllSelected}
					onChange={toggleSelectAll}
				/>
			</th>
			{hasNameColumn && <th style={cellStyle}>Nombre</th>}
			<th style={cellStyle}>Inicio</th>
			<th style={cellStyle}>Fin</th>
			<th style={cellStyle}>Tipo</th>
			<th style={cellStyle}></th>
		</tr>
	  </thead>
	  <tbody>
	  {leaveResults.map((item, index) => (
		  <tr key={index}>
		  <td style={{ ...cellStyle, textAlign: 'center' }}>
			<input
				type="checkbox"
				checked={selectedRows.has(item.id)}
				onChange={() => toggleSelectRow(item.id)}
			/>
		  </td>
		  {hasNameColumn && (
			  <td style={cellStyle}>{item.name_surname || '—'}</td>
		  )}
		  <td style={cellStyle}>{new Date(item.start_time).toLocaleString()}</td>
		  <td style={cellStyle}>{new Date(item.end_time).toLocaleString()}</td>
		  <td style={cellStyle}>{item.type}</td>
		  <td style={{ ...cellStyle, textAlign: 'center' }}>
			<button onClick={() => handleDeleteOne(item.id)} title="Eliminar">
				🗑️
			</button>
      </td>
		  </tr>
	  ))}
	 </tbody>
    </table>
  </div>
)}
	  
    </div>
  );
};

export default AdminListLeave;